(function () {
  'use strict';

  angular.module('app').component('activityLogList', activityLogList());

  function activityLogList() {
    return {
      bindings: {},
      controller: ActivityLogListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/activity-logs/activity-log-list/activity-log-list.component.html',
    };
  }

  ActivityLogListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'moment',
    'TransactionReportService',

    // Angular downgraded service
    'userService',
  ];

  function ActivityLogListCtrl(
    config,
    UtilService,
    SessionService,
    moment,
    TransactionReportService,

    // Angular downgraded service
    userService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.isFormValid = true;

    const apiUrl = 'activity_logs';
    vm.urlXls = apiUrl + '/export_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_pdf.pdf';
    vm.reportName = 'activity_logs';

    // private properties
    // -----------------------
    const companyId = SessionService.getSelectedAccountCompany().id;
    // const dateDisplay = config.DATE_DISPLAY_SHORT;
    const dateTimeDisplay = config.DATE_DISPLAY_SHORT_HOUR;

    let userLanguageCode = SessionService.getUserLanguage().code;
    let dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    // public methods
    // -----------------------
    vm.onSearched = function () {
      if (!vm.isFormValid) return;

      getReports();
    };

    vm.onSearchCleared = function () {
      vm.items = [];
      vm.meta = [];

      setDefaultFilters();

      // checkIsFormInvalid(); // TODO: ???
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      getReports();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      getReports();
    };

    vm.clearSearch = function () {
      vm.onSearchCleared();
    };

    vm.$onInit = function () {
      setDefaultFilters();

      documentDatePicker();

      getCompanyUsers();
    };

    // private methods
    // -----------------------
    let filterByDocumentDate = () => {
      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.documentDatePicker.startDate
      );
      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);
    };

    function setDefaultFilters() {
      vm.documentDatePicker = {
        startDate: moment().startOf('month'),
        endDate: moment(),
      };

      vm.filterCriteria = TransactionReportService.getFilterCriteria('created_at', 'desc');

      if (vm.companyUsers) {
        vm.filterCriteria.by_user_id = vm.companyUsers[0].id;
      }

      filterByDocumentDate();
    }

    function documentDatePicker() {
      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }

    function getReports() {
      vm.filterCriteria.lang = userLanguageCode;

      vm.loadingReports = true;
      TransactionReportService.getTransactionsReport(vm.filterCriteria, apiUrl).then(function (
        data
      ) {
        vm.items = data.items;
        vm.meta = data.meta;

        // console.log(vm.items);

        vm.items.forEach((item) => {
          item.created_at = moment(item.created_at).format(dateTimeDisplay);

          let user = vm.companyUsers.find((user) => user && user.id === item.user_id);
          item.user_name =
            user && user.first_name ? user.first_name + ' ' + (user.last_name || '') : '-';
        });

        vm.loadingReports = false;
      });
    }

    function getCompanyUsers() {
      vm.loadingCompanyUsers = true;

      let params = {
        get: 'active',
        by_company_id: companyId,
        skip_check_role: true,
      };

      userService.getUsers(params).subscribe((response) => {
        vm.companyUsers = response;

        vm.companyUsers.unshift({
          label: 'ALL',
          id: '',
        });

        vm.filterCriteria.by_user_id = vm.companyUsers[0].id;

        vm.loadingCompanyUsers = false;
      });
    }
  }
})();
